import { useEffect, useState } from "react";
import Modal from "react-modal";
import { useMutation } from "react-query";
import { v4 as uuidv4 } from "uuid";
import QuizView from "./QuizView";
import { Button } from "../common/Forms";
import Icon from "../common/Icon";
import { deleteQuiz } from "../../api";

const QuizViewModal = ({
  open,
  data: d,
  auth,
  onDuplicate,
  onUpdate,
  onClose,
}) => {
  const [page, setPage] = useState(0);
  const [dupData, setDupdata] = useState(null);
  const [data, setData] = useState(null);

  const deleteMttn = useMutation({
    mutationFn: deleteQuiz,
    onSettled: (res) => {
      const { result, error } = res;
      if (result) {
        setData(null);
        onClose();
      }
      if (error) {
        alert(error);
      }
    },
  });

  const next = () => {
    setPage((v) => v + 1);
  };
  const prev = () => {
    setPage((v) => v - 1);
  };

  const handleDelete = () => {
    // eslint-disable-next-line no-restricted-globals
    if (confirm("이 퀴즈를 삭제하시겠습니까?")) {
      deleteMttn.mutate(data.id);
    }
  };

  const handleDuplicate = () => {
    if (page === 0) {
      const { title, answers, contents, questions, options } = data;
      const list = questions.reduce((acc, cur, i) => {
        const id = uuidv4();
        return [
          ...acc,
          { id, key: id, q: cur, option: options[i], answers: answers[i] },
        ];
      }, []);
      setDupdata({ data: { title, contents, list }, lecture_id: null });
      next();
    }
    if (page === 1) {
      onDuplicate(dupData);
    }
  };
  const handleSelect = (e) => {
    setDupdata({ ...dupData, lecture_id: e.target.value });
  };

  useEffect(() => {
    setData(d);
  }, [d]);

  return (
    <>
      {open && (
        <Modal
          ariaHideApp={false}
          className="h-full text-center flex"
          isOpen={open}
          onRequestClose={onClose}
        >
          <div className="card bg-white w-full h-full m-auto md:w-9/12 md:shadow-xl md:min-h-[50vh] md:max-h-[83.4vh]">
            {page === 0 && (
              <div className="card-body overflow-hidden scale-90 m-[-2rem]">
                <div className="text-start h-full overflow-scroll scrollbar-hide border border-zinc-200 rounded-md">
                  <QuizView {...data} />
                </div>
                <div className="card-actions mt-4 w-full">
                  <div className="inline-flex gap-2 w-full">
                    <Button
                      type="accent"
                      className="flex-auto"
                      onClick={() => onUpdate(data.id)}
                    >
                      <Icon
                        name="pencil-square"
                        size="sm"
                        className="inline-block"
                      />
                      수정
                    </Button>
                    {auth && (
                      <Button
                        type="error"
                        className="flex-auto"
                        onClick={handleDelete}
                      >
                        <Icon
                          name="pencil-square"
                          size="sm"
                          className="inline-block"
                        />
                        삭제
                      </Button>
                    )}
                    <Button
                      type="primary"
                      className="flex-auto"
                      onClick={handleDuplicate}
                    >
                      <Icon
                        name="document-duplicate"
                        size="sm"
                        className="inline-block"
                      />
                      복제
                    </Button>
                  </div>
                  <Button
                    className="w-full bg-zinc-300 border-0 text-black hover:bg-zinc-400"
                    onClick={onClose}
                  >
                    <Icon name="x" size="sm" className="inline-block" />
                    닫기
                  </Button>
                </div>
              </div>
            )}
            {page === 1 && (
              <div className="card-body overflow-hidden scale-90 m-[-2rem]">
                <div className="text-start h-full border border-zinc-200 rounded-md flex flex-col p-4 gap-4 flex-1">
                  <div className="inline-flex gap-4 items-center">
                    <h3 className="text-sm font-bold w-12 text-end">강의</h3>
                    <select
                      id="classes"
                      name="classes"
                      autoComplete="classes-name"
                      className="h-12 mt-1 block w-full rounded-md border border-gray-300 bg-white py-2 px-3 shadow-sm focus:border-cyan-500 focus:outline-none focus:ring-cyan-500 sm:text-sm"
                      onChange={handleSelect}
                    >
                      {data.lectureList.map(({ _id: id, title: v }) => (
                        <option key={`option_${v}`} value={id}>
                          {v}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="card-actions mt-4 w-full">
                  <div className="inline-flex gap-2 w-full">
                    <Button
                      className="flex-auto bg-zinc-300 border-0 text-black hover:bg-zinc-400"
                      onClick={prev}
                    >
                      <Icon
                        name="chevron-left"
                        size="sm"
                        className="inline-block"
                      />
                      이전
                    </Button>
                    <Button
                      type="primary"
                      className="flex-auto"
                      onClick={handleDuplicate}
                    >
                      <Icon
                        name="document-duplicate"
                        size="sm"
                        className="inline-block"
                      />
                      복제
                    </Button>
                  </div>
                  <Button
                    className="w-full bg-zinc-300 border-0 text-black hover:bg-zinc-400"
                    onClick={onClose}
                  >
                    <Icon name="x" size="sm" className="inline-block" />
                    닫기
                  </Button>
                </div>
              </div>
            )}
          </div>
        </Modal>
      )}
    </>
  );
};

export default QuizViewModal;
